<template>
  <Can action="view" subject="banner">
    <div data-component-group="banner-dialog" data-component="edit">
      <dialog-edit
        icon="layers"
        :to="`/site-messages/${activeBanner?.id}`"
        :title="activeBanner.name"
        content-class="edit-banner-dialog"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-banner-edit
            :banner="activeBanner"
            :is-loading="isEditingBanner"
            :on-cancel="onCancel"
            :on-submit="$ability.can('update', 'banner') ? updateBanner : undefined"
          />
        </template>
      </dialog-edit>
    </div>
  </Can>
</template>

<script>
  export default {
    data() {
      return {
        isEditingBanner: false,
      };
    },
    created() {
      if (!this.activeBanner?.id) {
        this.$store.dispatch('siteMessages/getItem', { id: this.$route.params.id });
      }
    },
    computed: {
      activeBanner() {
        return this.$store.getters['siteMessages/activeItem'];
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'site-messages' });
      },
      updateBanner(banner) {
        const nextBannerItem = {
          ...banner,
          id: this.activeBanner.id,
        };

        this.isEditingBanner = true;

        return this.$store
          .dispatch('siteMessages/update', nextBannerItem)
          .then((res) => {
            this.$router.push({ name: 'site-messages', query: { status: 'success' } });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isEditingBanner = false;
          });
      },
    },
  };
</script>
